import React from 'react';

const PortalContainerRef = React.createRef<HTMLDivElement>();
export default PortalContainerRef;

export const PortalContainer = (): JSX.Element => {
  return <div ref={PortalContainerRef} />;
};
